const Settings = () => {
    return <h2>Ajustes</h2>;
  };
  export default Settings;